import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { fg } from '@atlaskit/platform-feature-flags';
import { getExperimentCohort } from '@atlassian/generative-ai-modal/utils/experiments';
import { DELAY_BETWEEN_TWO_CHECKS, DELAY_INCREASE, MAX_DELAY, NUMBER_OF_BLOCKS_PER_REQUEST, NUMBER_OF_REQUESTS_FOR_INCREASE, NUMBER_OF_SENTENCES_PER_REQUEST } from '../pm-plugins/ai-spelling-grammar/document-sg-checker';
// Note -- when updating this function -- also update
// the one used in packages/editor/editor-plugin-ai/examples/utils/getDevFetchCustomHeaders.ts
export function _getFetchCustomHeaders() {
  var currentHost = window.location.origin;
  switch (true) {
    case currentHost === 'https://statlas.prod.atl-paas.net':
      // Update this to add custom headers when run in atlaskit branch deploys
      // ie.
      // {
      //   'X-CloudID': 'Magic string'
      // }
      return {};
    default:
      return {};
  }
}
export function deriveHost() {
  var _ref = typeof window.location !== 'undefined' ? window.location : {},
    _ref$origin = _ref.origin,
    origin = _ref$origin === void 0 ? '' : _ref$origin,
    _ref$port = _ref.port,
    port = _ref$port === void 0 ? '' : _ref$port,
    _ref$hostname = _ref.hostname,
    hostname = _ref$hostname === void 0 ? '' : _ref$hostname;
  if (hostname === 'localhost' && port !== '8081' || ['atlaskit-website-staging.stg-east.frontend.public.atl-paas.net', 'statlas.prod.atl-paas.net', 'atlaskit.atlassian.com'].some(function (h) {
    return hostname === h;
  })) {
    return 'https://pug.jira-dev.com';
  }
  return origin;
}
export function deriveGenerativeAIApiUrl() {
  return "".concat(deriveHost(), "/gateway/api/editor-ai/v1/generative/ai");
}

/**
 * Tech Spec: https://hello.atlassian.net/wiki/spaces/CA3/pages/3776161653/Bulk+Spelling+and+Grammar+Endpoint
 */
export function deriveProactiveAISpellingAndGrammarApiUrl() {
  var version = fg('platform_editor_ai_proactive_ai_md_plus') ? 'v2' : 'v1';
  var url = new URL("/gateway/api/".concat(version, "/grammar"), deriveHost());
  var variation = getExperimentCohort('editor_ai_-_proactive_ai_model_variations');
  if (variation !== 'control' && variation !== 'not-enrolled') {
    url.searchParams.set('variation', variation);
  }
  return url.toString();
}
export function deriveProactiveAIApiUrl() {
  // return `${deriveHost()}/gateway/api/v1/grammar`;
  return "".concat(deriveHost(), "/gateway/api/assist/api/v2/ai-feature/proactive");
}
var DEFAULT_CURRENT_CHUNKS_DEBOUNCED_TIME = 4000;
var DEFAULT_CURRENT_CHUNKS_DEBOUNCED_WAIT_TIME = 30000;
var DEFAULT_NON_CURRENT_CHUNKS_THROTTLED_TIME = 2000;
export function deriveProactiveAIConfig(overrides) {
  return _objectSpread({
    enabled: false,
    apiUrl: deriveProactiveAISpellingAndGrammarApiUrl(),
    defaultToggledState: false,
    timings: {
      currentChunks: DEFAULT_CURRENT_CHUNKS_DEBOUNCED_TIME,
      currentChunksMaxWait: DEFAULT_CURRENT_CHUNKS_DEBOUNCED_WAIT_TIME,
      nonCurrentChunks: DEFAULT_NON_CURRENT_CHUNKS_THROTTLED_TIME
    },
    documentSGChecker: {
      enabled: true,
      blocksPerRequest: NUMBER_OF_BLOCKS_PER_REQUEST,
      sentencesPerRequest: NUMBER_OF_SENTENCES_PER_REQUEST,
      timings: {
        delayBetweenChecks: DELAY_BETWEEN_TWO_CHECKS,
        numberOfRequestsForIncrease: NUMBER_OF_REQUESTS_FOR_INCREASE,
        delayIncrease: DELAY_INCREASE,
        maxDelay: MAX_DELAY
      }
    }
  }, overrides);
}
export var convoAIStatelessApiURL = "".concat(deriveHost(), "/gateway/api/assist/chat/v1/invoke_agent/stream");
export var convoAIStatefulApiURL = "".concat(deriveHost(), "/gateway/api/assist/chat/v1/channel"); // + `/${channelID}/message/stream` at the end;